import React from 'react';
import {Info} from 'lucide-react';
import {dropdown} from 'assets/images/images';
import {SkeletonLoader} from 'components';

const StatusDropdown = ({
  label,
  value,
  options,
  onSelect,
  isLoading,
  dropdownRef,
  isOpen,
  setIsOpen,
}) => {
  const currentOption = options.find(opt => opt.value === value) || options[0];

  return (
    <div
      className="bg-white rounded p-4 flex items-start gap-1 w-full flex-col relative"
      ref={dropdownRef}
    >
      <p className="text-[#080917] text-[10px] font-normal uppercase">
        {label}
      </p>
      {isLoading ? (
        <SkeletonLoader style={{width: 150, height: 24, marginBottom: 10}} />
      ) : (
        <div
          className={`border-[0.5px] cursor-pointer rounded-lg py-3 px-3 flex items-center justify-between w-full ${
            isOpen ? 'border-brandBlue' : 'border-[#cccccc]'
          }`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div
            className="py-1 px-2 rounded-full text-[10px] w-fit uppercase font-normal flex items-center gap-2"
            style={{
              backgroundColor: currentOption.color,
              color: currentOption.textColor,
            }}
          >
            {label === 'Match status' && (
              <Info color={currentOption.textColor} size={12} />
            )}
            {currentOption.value}
          </div>
          <img
            src={dropdown}
            className={`w-4 h-4 ${isOpen ? 'rotate-180' : ''}`}
          />
        </div>
      )}
      <div
        className={`absolute top-full left-0 right-0 mt-1 p-4 space-y-4 bg-white border-[0.5px] border-[#cccccc] rounded shadow-lg z-10 overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 hidden'
        }`}
      >
        {options.map(option => (
          <div
            key={option.value}
            className="hover:bg-gray-50 cursor-pointer transition-colors w-fit"
            onClick={() => onSelect(option)}
          >
            <div
              className="py-1 px-2 rounded-full text-[10px] w-fit uppercase font-normal flex items-center gap-2"
              style={{backgroundColor: option.color, color: option.textColor}}
            >
              {label === 'Match status' && (
                <Info color={option.textColor} size={12} />
              )}
              {option.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusDropdown;
